export const URL_CHANGED = 'URL_CHANGED';

export interface UrlState<TParams = Record<string, any>> {
    path: string;
    params: TParams;
    hash: Record<string, any>;
}
export type UrlAction<TParams = Record<string, any>> = { type: typeof URL_CHANGED; payload: UrlState<TParams> };

/** Processes a url change and add it to state */
export const urlChanged = <TParams>(url: UrlState<TParams>) => ({
    type: URL_CHANGED,
    payload: url,
});
